import React from 'react';
import { Lock, BadgeCheck } from 'lucide-react';
export function Footer() {
  return <footer className="border-t border-brand-light bg-white px-6 py-12 lg:px-8" data-id="element-98">
      <div className="mx-auto flex max-w-6xl flex-col items-center justify-between gap-7 text-center md:flex-row md:text-left" data-id="element-99">
        <div data-id="element-100">
          <div className="text-2xl font-extrabold tracking-tight text-brand-navy" data-id="element-101">
            LIBROFY<span className="text-brand-accent" data-id="element-102">.STORE</span>
          </div>
          <p className="mt-2 max-w-sm text-sm text-brand-navy/60" data-id="element-103">
            El sistema para profesionales que cobran lo que valen.
          </p>
        </div>

        <div className="flex flex-col items-center gap-4 md:items-end" data-id="element-104">
          <div className="flex flex-wrap justify-center gap-4 text-sm font-semibold text-brand-navy/70" data-id="element-105">
            <span className="flex items-center gap-1.5" data-id="element-106">
              <Lock className="h-4 w-4 text-brand-accent" data-id="element-107" /> Pago seguro
            </span>
            <span className="flex items-center gap-1.5" data-id="element-108">
              <BadgeCheck className="h-4 w-4 text-brand-green" data-id="element-109" /> Pago único
            </span>
          </div>
          <div className="flex gap-5 text-sm text-brand-navy/60" data-id="element-110">
            <a href="#" className="transition hover:text-brand-accent" data-id="element-111">
              Contacto
            </a>
            <a href="#" className="transition hover:text-brand-accent" data-id="element-112">
              Términos
            </a>
            <a href="#" className="transition hover:text-brand-accent" data-id="element-113">
              Privacidad
            </a>
          </div>
        </div>
      </div>
      <p className="mx-auto mt-8 max-w-6xl border-t border-brand-light pt-6 text-center text-xs text-brand-navy/40" data-id="element-114">
        © {new Date().getFullYear()} LIBROFY.STORE. Todos los derechos
        reservados.
      </p>
    </footer>;
}